module.exports = __webpack_public_path__ + "static/media/page-loader.de05c3ca.gif";